<template>
    <div class="sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center justify-center">
        <img class="mx-auto h-10 w-auto" src="@/assets/images/logo/logo.png" alt="Your Company" />
        <p class="ms-4 text-3xl font-medium capitalize">Inventree</p>

    </div>
</template>

<script setup>

</script>

<style scoped>

</style>